module.exports = __webpack_public_path__ + "img/dku.02860.8c243bee.png";